// Home Products Data - Skin and Hair Categories

export const skinProducts = [
  {
    id: 1,
    name: "Salmon DNA Sodium Essence",
    image: "/images/skinproducts/product1.png",
    category: "skin"
  },
  {
    id: 2,
    name: "ReMedium PDRN + HA Complex",
    image: "/images/skinproducts/product2.png",
    category: "skin"
  },
  {
    id: 3,
    name: "LeVair",
    image: "/images/skinproducts/product3.png",
    category: "skin"
  },
  {
    id: 4,
    name: "Hyaron Skin Booster",
    image: "/images/skinproducts/product4.png",
    category: "skin"
  },
  {
    id: 5,
    name: "PDX Skin Booster",
    image: "/images/skinproducts/product5.png",
    category: "skin"
  },
  {
    id: 6,
    name: "iSkin Radianz Blu Cell",
    image: "/images/skinproducts/product6.png",
    category: "skin"
  },
  {
    id: 7,
    name: "Glutax 2000000C DULANA",
    image: "/images/skinproducts/product7.png",
    category: "skin"
  },
  {
    id: 8,
    name: "Vesco Pharma Collagen C 1000",
    image: "/images/skinproducts/product8.png",
    category: "skin"
  }
];

export const hairProducts = [
  
  {
    id: 3,
    name: "BOSIDIN Hair Removal Device",
    image: "/images/hairproducts/12.png",
    category: "hair"
  },
  {
    id: 4,
    name: "Hair Laser Comb",
    image: '/images/hairproducts/11.png',
    category: "hair"
  },
  {
    id: 5,
    name: "Dermaheal HL",
    image: '/images/hairproducts/10.png',
    category: "hair"
  },
  {
    id: 6,
    name: "Heating Therapy Laser Cap",
    image:'/images/hairproducts/9.png',
    category: "hair"
  }
  
  
];